"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchProvinceNewRequest = void 0;
var SearchProvinceNewRequest = /** @class */ (function () {
    function SearchProvinceNewRequest() {
    }
    return SearchProvinceNewRequest;
}());
exports.SearchProvinceNewRequest = SearchProvinceNewRequest;
;
//# sourceMappingURL=searchProvinceNew.request.js.map